import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Auth } from "aws-amplify";

// Types
import { SignedKey } from "../../types/signedKey";

// State
import { setSignedKey } from "../signedKeySlice";
import { SignKeyForm as SignKeyFormNS } from "../signKeyFormSlice";

// Helpers
import { API_URL } from "../../consts";

export const signKeyApi = createApi({
  reducerPath: "signKey",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    async prepareHeaders(headers: Headers): Promise<Headers> {
      const session = await Auth.currentSession();
      const jwtToken = session.getIdToken().getJwtToken();

      headers.set("Authorization", `Bearer ${jwtToken}`);

      return headers;
    },
  }),
  tagTypes: ["SignedKey"],
  endpoints: (builder) => ({
    signKey: builder.mutation<SignedKey, SignKeyFormNS.Values>({
      query: ({ sourceAddress, ...values }) => ({
        url: "signings",
        method: "POST",
        body: {
          ...values,
          sourceAddress: [...sourceAddress.split(/, */)],
        },
      }),
      invalidatesTags: ["SignedKey"],
      async onCacheEntryAdded(
        _arg: SignKeyFormNS.Values,
        { dispatch, getCacheEntry, cacheDataLoaded }
      ) {
        await cacheDataLoaded;

        dispatch(setSignedKey(getCacheEntry().data));
      },
    }),
  }),
});

export const { useSignKeyMutation } = signKeyApi;
